import { useParams } from '@tanstack/react-router';

import { updateTranscriptionSegmentsSpeaker } from '../../../ducks/asset_transcriptions/thunks';
import { selectTranscriptionPartsAndSpeakerLabels } from '../../../panels/asset_transcriptions/selectors';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../store/react_redux_typed';
import ControlsModal from '../../../ui/controls_modal/controls_modal';
import Label from '../../../ui/label/label';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';

type SpeakerSegmentIds = {
  id: string;
  segmentsIds: string[];
};

export type TranscriptionsConfirmChangeSegmentsSpeakerProps =
  ModalComponentProps & ContextItemsHocProps<SpeakerSegmentIds>;

function TranscriptionsConfirmChangeSegmentsSpeaker({
  item,
  isOpen,
  onCancel,
  onConfirm,
}: TranscriptionsConfirmChangeSegmentsSpeakerProps) {
  const dispatch = useAppDispatch();
  const { id: assetId } = useParams({ strict: false });

  const { speakerLabels } = useAppSelector((state) =>
    selectTranscriptionPartsAndSpeakerLabels(state, assetId),
  );
  const speakerName = speakerLabels[item.id];

  return (
    <ControlsModal
      headerText={
        <>
          Change speaker to <strong>{speakerName}</strong>
        </>
      }
      confirmButtonText="Confirm"
      variant="warning"
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={() => {
        const speakerId = parseInt(item.id, 10);
        return dispatch(
          updateTranscriptionSegmentsSpeaker(item.segmentsIds, speakerId),
        ).then(onConfirm);
      }}
    >
      Do you want to change the speaker of this part to:{' '}
      <Label variant="gray">{speakerName}</Label>
    </ControlsModal>
  );
}

export const TranscriptionsConfirmChangeSegmentsSpeakerModal = withContextItems(
  TranscriptionsConfirmChangeSegmentsSpeaker,
);
